/* eslint-disable import/prefer-default-export */
import { DOCUMENT } from '@/constants/config';
import { capitalizeEveryWordFirstLetter, formatDate } from '@/helpers';

const getSigningDate = data => {
    if(data.is_physically_signed) {
        return capitalizeEveryWordFirstLetter(DOCUMENT.STATUES.PHYSICALLY_SIGNED);
    }
    if(data.is_dropbox_signed) {
        return capitalizeEveryWordFirstLetter(DOCUMENT.STATUES.DROPBOX_SIGNED);
    }
    if(data.is_mark_as_signed) {
        return capitalizeEveryWordFirstLetter(DOCUMENT.STATUES.MARK_AS_SIGNED);
    }

    return formatDate(data.signed_at);
};

export const localize = data => ({
    id: data.id,
    companyProcessId: data.company_process_id,
    name: data?.user_name,
    url: data.pdf_url,
    fileName: data.name,
    status: data.status,
    processStatus: data.status,
    date: formatDate(data.date),
    signDate: getSigningDate(data),
    isSigning: data.is_signing,
    sentOn: formatDate(data.sent_at),
    doesItNeedSignature: data.does_it_need_signature,
    requestingDocumentSignatureStatus: false,
    requestingDocumentSignatureStatusForViewing: false,
    isExternalPdf: data.is_external_pdf,
});
